import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Editor as H2Editor } from "../H1Block/Editor";
import { H2 } from "./H2Block";
import { defaultData } from "./H2BlockDefaultData";
import { meta } from "./H2BlockMetaData";

export const H2Block: BlockExport = {
  type: "component",
  Block: H2,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-heading",
    size: 24,
  },
  Editor: H2Editor,
  defaultData,
  meta,
};
